export class LanguageModel {
    id: string;
    name: string;
    icon: string;

    constructor(id: string, name: string, icon: string) {
        this.id = id;
        this.name = name;
        this.icon = icon;
    }
}